module.exports = __webpack_public_path__ + "img/iconImg3.b0d147d0.png";